import { render, staticRenderFns } from "./classForm.vue?vue&type=template&id=1b77c9b8&scoped=true"
import script from "./classForm.vue?vue&type=script&lang=js"
export * from "./classForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b77c9b8",
  null
  
)

export default component.exports